// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "PageListItem-module--wrapper--Z9lrw";
export var actionWrapper = "PageListItem-module--actionWrapper--4nRjq";
export var linkWrapper = "PageListItem-module--linkWrapper--ebqSL";
export var link = "PageListItem-module--link--WAphi";
export var text = "PageListItem-module--text--hom8E";
export var icon = "PageListItem-module--icon--FSLJ9";
export var number = "PageListItem-module--number--YMMLT";
export var label = "PageListItem-module--label--w6Lz5";
export var description = "PageListItem-module--description--nzW9e";